/**
 * Properties reducer.
 * @module reducers/toolbar/toolbar
 */

import { GET_CATEGORIES } from '../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  firstLoad: true,
  data: {},
};

/**
 * categories reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function categories(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_CATEGORIES}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        firstLoad: false,
        data: {},
      };
    case `${GET_CATEGORIES}_SUCCESS`:
      // "hasErro": false,
      // "mensagem": null,
      // "resposta": [

      if (action.result?.hasErro) {
        return {
          ...state,
          error: action.result?.mensagem,
          loaded: false,
          loading: false,
          firstLoad: false,
          data: {},
        };
      }

      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        firstLoad: false,
        data: action.result.resposta,
      };
    case `${GET_CATEGORIES}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        firstLoad: false,
        data: {},
      };
    default:
      return state;
  }
}
